import type { Direction } from "./locale-registry";

export interface DirectionalPair<T> {
  ltr: T;
  rtl: T;
}

/** Pick a direction-sensitive value without coupling behavior to a language. */
export const byDirection = <T>(direction: Direction, pair: DirectionalPair<T>): T =>
  direction === "rtl" ? pair.rtl : pair.ltr;

/** Normalize a physical pointer x-coordinate to 0..1 from inline-start. */
export const inlineAxisRatio = (
  clientX: number,
  physicalLeft: number,
  physicalRight: number,
  direction: Direction,
): number => {
  const width = physicalRight - physicalLeft;
  if (!Number.isFinite(width) || width <= 0) return 0;
  const raw = direction === "rtl"
    ? (physicalRight - clientX) / width
    : (clientX - physicalLeft) / width;
  return Math.min(1, Math.max(0, raw));
};

/**
 * Rail disclosure glyphs point toward the space that will be opened/closed.
 * The rail is on inline-start: left in LTR and right in RTL.
 */
export const railToggleIcon = (
  mode: "mini" | "expanded",
  direction: Direction,
): "chev-left" | "chev-right" => {
  if (mode === "mini") return byDirection(direction, { ltr: "chev-right", rtl: "chev-left" });
  return byDirection(direction, { ltr: "chev-left", rtl: "chev-right" });
};
